import {connect} from 'react-redux'

import {TravelOverview} from './traveloverview.component'
import {updateOrigin, updateReturn, updateReturnToOrigin, updateOriginToReturn, onAddTransportation, onRemoveTransportation, onUpdateTransportationReservation} from '../planner/planner.action'

import legUtil from '../util/leg.util'
import userUtil from '../util/user.util'


const mapStateToProps = (state) => {
    let leg = legUtil.getActiveLeg(state)

    return {
  	prevLeg: legUtil.getPrevLeg(state),
  	nextLeg: legUtil.getNextLeg(state),
        leg: leg,
        legs: state.getIn(['document', 'legs']),
        hasTravel: !legUtil.getTransportation(state, leg.getIn(['id'])).isEmpty(),
        origination: state.getIn(['document', 'properties', 'origination']),
        return: state.getIn(['document', 'properties', 'return']),
        transportation: legUtil.getTransportation(state, leg.getIn(['id'])),
        user: userUtil.getCurrentUser(state),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onUpdateOrigin: (destination) => {
            dispatch(updateOrigin(destination))
        },
        onUpdateReturn: (destination) => {
            dispatch(updateReturn(destination))
        },
        onMatchReturnToOrigin: (destination) => {
            dispatch(updateReturnToOrigin(destination))
        },
        onMatchOriginToReturn: (destination) => {
            dispatch(updateOriginToReturn(destination))
        },
        onAddTransportation: (depLeg, arrLeg, depCity, arrCity, transportation, user) =>{
            dispatch(onAddTransportation(depLeg, arrLeg, depCity, arrCity, transportation, user))
        },
        onRemoveTransportation: (transportation) =>{
            dispatch(onRemoveTransportation(transportation))
        },
        onUpdateTransportationReservation: (depLeg, arrLeg, depCity, arrCity, transportation) => {
            dispatch(onUpdateTransportationReservation(depLeg, arrLeg, depCity, arrCity, transportation))
        },
    }
}

const TravelContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(TravelOverview)

export default TravelContainer
